// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#experience *{word-break:break-word}#experience .card-body{overflow:auto;max-height:480px;padding-top:0!important}#experience .card-text{margin-top:1rem}#experience #btn-add{width:100%;padding:.3rem 10px!important;margin-top:1rem}#experience li:not(:first-child){border-top:1px dotted #dbdbdb}#experience .ghost{opacity:.5;background:#c8ebfb}#experience li{background-color:#fff}#experience .grab{cursor:-webkit-grab!important;cursor:grab!important}", ""]);
// Exports
module.exports = exports;
